export const modifyDataForm = [
    {
        cols: [
            {
                formGroup: 'modifyDataForm',
                class: 'col-12',
                title: 'Datos modificables',
                titleClass: 'text-center form-title-2 mt-5'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-md-6 col-10',
                item: 'input',
                type: 'text',
                label: 'Dirección',
                formControlName: 'address',
                inputClass: 'text-input'
            },
            {
                class: 'col-md-6 col-10',
                item: 'input',
                type: 'text',
                label: 'Población',
                formControlName: 'population',
                inputClass: 'text-input'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-md-6 col-10',
                item: 'select',
                type: 'provinces',
                label: 'Provincia',
                formControlName: 'province',
                inputClass: 'text-input'
            },
            {
                class: 'col-md-6 col-10',
                item: 'input',
                type: 'text',
                label: 'CP',
                formControlName: 'cp',
                inputClass: 'text-input'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-md-6 col-10',
                item: 'button',
                type: 'regular',
                placeholder: 'Guardar datos',
                inputClass: 'form-button btn btn-primary',
                buttonAction: 'onSubmit'
            }
        ]
    }
];
